import { Route } from "react-router-dom";
import Protected from "../../auth/Protected";
import { UserRole } from "../../../enums";
import ExerciseCategoriesPage from "./ExercisesPage";
import ExerciseCategoryCreatePage from "./ExerciseCreatePage";
import ExerciseCategoryEditPage from "./ExerciseEditPage";
import ExercisesPage from "./ExercisesPage";
import ExerciseCreatePage from "./ExerciseCreatePage";
import ExerciseEditPage from "./ExerciseEditPage";
 

export default (
  <Route path="exercises">
    <Route
      index
      element={
        <Protected
          path="/admin/exercises"
          roles={[UserRole.ADMIN, UserRole.SUPERADMIN]}
        >
          <ExercisesPage />
        </Protected>
      }
    />

    <Route
      path="create"
      element={
        <Protected
          path="/admin/exercises/create"
          roles={[UserRole.ADMIN, UserRole.SUPERADMIN]}
        >
          <ExerciseCreatePage />
        </Protected>
      }
    />
    
    <Route
      path="edit/:id"
      element={
        <Protected
          path="/admin/exercises/edit/:id"
          roles={[UserRole.ADMIN, UserRole.SUPERADMIN]}
        >
          <ExerciseEditPage />
        </Protected>
      }
    />  
  </Route>
);
